import LoginComponent from './LoginComponent';
import LogoutComponent from './LogoutComponent';

import { cognitoCoreStrategy } from './CoreStrategy';

const cognitoStrategy = {
  ...cognitoCoreStrategy,
  LoginComponent,
  LogoutComponent,
};

export { cognitoStrategy };
